<template>
  <div>
    <v-dialog v-model="dialog" persistent eager scrollable max-width="500px">
      <v-form ref="CPMTUtilsDialog" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>College Performance Management Team</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    outlined
                    small-chips
                    required
                    deletable-chips
                    v-model="year"
                    :rules="[formRules.required]"
                    :items="yearSelection"
                    dense
                    class="rounded-lg"
                    label="Year"
                    color="#6DB249"
                  >
                  </v-autocomplete
                ></v-col>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    outlined
                    small-chips
                    required
                    deletable-chips
                    v-model="position"
                    :rules="[formRules.required]"
                    :items="positionList"
                    item-value="id"
                    item-text="name"
                    dense
                    class="rounded-lg"
                    @change="changePosition()"
                    label="Position"
                    color="#6DB249"
                  >
                  </v-autocomplete
                ></v-col>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    outlined
                    small-chips
                    required
                    deletable-chips
                    v-model="employee"
                    :rules="[formRules.required]"
                    :items="formatEmployeeNameList"
                    item-value="usID"
                    item-text="name"
                    dense
                    class="rounded-lg"
                    label="Employee"
                    color="#6DB249"
                  >
                  </v-autocomplete
                ></v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              color="#519043"
              class="white--text"
              v-if="action == 'Add'"
              @click="addCPMT()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Add
            </v-btn>
            <v-btn
              color="#519043"
              class="white--text"
              v-if="action == 'Update'"
              @click="updateCPMT()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: null,
    action: null,
    tab: null,
  },
  data() {
    return {
      dialog: false,
      positionList: [
        { id: 1, name: "Chairperson" },
        { id: 2, name: "Member" },
      ],
      position: 2,
      employeeList: [],
      employee: null,
      yearSelection: [],
      year: null,

      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },

  computed: {
    formatEmployeeNameList() {
      let toReturn = this.employeeList;
      let newData = [];
      if (this.position == 2) {
        for (let i = 0; i < toReturn.length; i++) {
          toReturn[i].name = this.toTitleCase(toReturn[i].name);
        }
        return toReturn;
      } else {
        if (this.tab == 1) {
          for (let i = 0; i < toReturn.length; i++) {
            if (toReturn[i].officeID == 38 && toReturn[i].roleID == 6) {
              newData.push(toReturn[i]);
            }
          }
        } else if (this.tab == 2) {
          for (let i = 0; i < toReturn.length; i++) {
            if (toReturn[i].officeID == 2 && toReturn[i].roleID == 6) {
              newData.push(toReturn[i]);
            }
          }
        } else if (this.tab == 3) {
          for (let i = 0; i < toReturn.length; i++) {
            if (toReturn[i].officeID == 65 && toReturn[i].roleID == 6) {
              newData.push(toReturn[i]);
            }
          }
        }
        for (let i = 0; i < newData.length; i++) {
          newData[i].name = this.toTitleCase(newData[i].name);
        }
        return newData;
      }
    },
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        if (data.id) {
          this.year = data.year;
          this.position = data.position;
          this.employee = data.user_detailID.toString();
          this.initialize();
        } else {
          //   this.$refs.CPMTUtilsDialog.reset();
          this.initialize();
        }
      },
      deep: true,
    },
  },

  methods: {
    initialize() {
      this.getEmpDetails();
      this.loadYearSelection();
    },

    getEmpDetails() {
      this.axiosCall(
        "/user-details/getUsersHeadProgChairAbove_Office",
        "GET"
      ).then((res) => {
        this.employeeList = res.data;
      });
    },

    loadYearSelection() {
      let d = new Date();
      this.yearSelection = [];
      const currentYear = d.getFullYear();
      const nextYear = currentYear + 1;
      this.year = currentYear;
      this.yearSelection.push(currentYear, nextYear);
    },
    addCPMT() {
      let data = {
        position: this.position,
        user_detailID: this.employee,
        year: this.year,
        composition: this.tab,
      };
      console.log(data);
      this.axiosCall("/cpmt-utils", "POST", data).then((res) => {
        if (res.data.status == 201) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.closeD();
        } else if (res.data.status == 400) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },
    updateCPMT() {
      let data = {
        position: this.position,
        user_detailID: this.employee,
        year: this.year,
        composition: this.tab,
      };
      console.log(data, this.data.id);
      this.axiosCall("/cpmt-utils/" + this.data.id, "PATCH", data).then(
        (res) => {
          if (res.data.status == 201) {
            this.closeD();
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = "Successfully updated job posting!";

            // location.reload();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        }
      );
    },
    changePosition() {
      this.getEmpDetails();
    },
    closeD() {
      this.eventHub.$emit("closeCPMTUtilsDialog", false);
      this.year = null;
      this.position = null;
      this.employee = null;
      this.dialog = false;
    },
  },
};
</script>
